
<app-topnav></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
        <div class="h-30"></div>
              <div class="facility-heading">{{'userProfileText'|translate:translations}}</div>
      <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading">{{'manageProfileText'|translate:translations}}</span>
        </div>

        <app-user-profile></app-user-profile>
        <div class="h-30"></div>
        <div class="form-buttons">
            <button type="button" class="submit-form-button" (click)="navigate()">{{'editProfileText'|translate:translations}}</button>
            <a routerLink="/change-password" class="submit-form-button cancel-button">{{'changePasswordText'|translate:translations}}</a>
        </div>
    </div>
    </form>
</div>
</div>
</div>
